export const RenewalPolicyFragment = gql`
  fragment RenewalPolicyFragment on RenewalPolicy {
    id
    name
    renewalMethod
    renewalExpiryBehavior
    renewalWindowValue
    renewalWindowUnit
    gracePeriodValue
    gracePeriodUnit
    latePeriodValue
    latePeriodUnit
    archivedAt
    expirationDateTemplate {
      ...DateTemplateFragment
    }
    renewalFees {
      id
      fee {
        id
        name
      }
    }
    renewalPolicyEmails {
      id
      phase
      daysOffset
      emailApplicant
      emailContent
      emailOwner
    }
    assignedRecordTemplates {
      id
      name
      archivedAt
    }
  }
`
